import { Directive } from '@angular/core';
import { environment } from '@env/environment';
import { DefaultImageDirective } from '@shared/directives/default-image.directive';

@Directive({
  selector: '[appDefaultPlaceholder]',
  standalone: true,
})
export class DefaultPlaceholderDirective extends DefaultImageDirective {
  default = environment.wordpressJipImages + 'placeholder.png';
}
